import { UserEvaluationConsult } from './Request';

export const consultTest = async ({ lessonId, userId }) => {
  const userEvaluationObject = UserEvaluationConsult({
    lessonId,
    userId,
  });

  return userEvaluationObject;
};

export default {
  consultTest,
};
